import { http } from '../../core/services/http';
import { TechnicalType } from '../interfaces/TechnicalType';

export const loadEquipmentTypes = () =>
  http.get<TechnicalType[]>('common/systemTypes/equipmentTypes').then(response => response.data);
